import React, { Component } from 'react'
import { connect } from 'react-redux'
import './index.scss'

import TemplateHelper from '@/utils/TemplateHelper'

import MoveButton from '../MoveButton'

import { Trans } from 'react-i18next'
import i18n from '../../../i18n'

class NewTemplates extends Component {
    render() {
        const { history, newTemplates, lang } = this.props

        return (
            <div className='old-new-templates-root-container'>
                <div className='heading-area'>
                    <div className="title">
                        {i18n.t("web.newhome.newtemplate.title")}
                        <img src="https://front.videomonster.com/images-7cuytg20/web/home/new-template-icon.svg" alt="" />
                    </div>
                    <div className="desc">
                        <Trans
                            i18nKey="web.newhome.newtemplate.desc"
                        >
                            <b />
                        </Trans>
                    </div>
                </div>
                <div className='template-area'>
                    {
                        newTemplates.map(item => (
                            <div className="video-container" onClick={this.props.onThumbnailClicked(item._id)}>
                                <video src={TemplateHelper.getPreviewVideo(item, lang)} autoPlay loop muted />
                            </div>
                        ))
                    }
                </div>
                <div className='make-video-btn'>
                    <MoveButton
                        history={history}
                        label={i18n.t("web.newhome.move.designselect")}
                        movePath={'/designselect'}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(NewTemplates)